<template>
  <span
    class="hidden"
    aria-hidden
  >
    This component is just to load overview
  </span>
</template>

<script setup lang="ts">
import { useCustomParams } from '@/composables/useCustomParams'
import { useSummary } from '@/composables/useSummary'
import { useConversationStore } from '@/stores/conversationStore'
import { BaseApiMessage } from '@/types/api'
import { storeToRefs } from 'pinia'
import { onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const conversationStore = useConversationStore()
const { messages, isThinking } = storeToRefs(conversationStore)
const { summaryMessage, loading } = useSummary()
const { url } = useCustomParams()
const { t } = useI18n()

onMounted(() => {
  isThinking.value = true
  const overviewPrompt = `${t('buttons.createOverview')}: ${url}`
  const newMessage = {
    content: overviewPrompt,
    role: 'user'
  } as BaseApiMessage
  messages.value.push(newMessage)
})

watch(
  loading,
  () => {
    if (!loading.value) {
      isThinking.value = false
      messages.value.push(summaryMessage)
    }
  },
  { immediate: true }
)
</script>
